var map = {
	"./1.jpg": 7542,
	"./10.jpg": 8300,
	"./11.jpg": 6345,
	"./12.jpg": 3262,
	"./13.jpg": 1099,
	"./14.jpg": 1096,
	"./2.jpg": 9681,
	"./3.jpg": 9732,
	"./4.jpg": 2463,
	"./5.jpg": 6082,
	"./6.jpg": 237,
	"./7.jpg": 2144,
	"./8.jpg": 7451,
	"./9.jpg": 7294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8808;